export const COMPETITOR_FEEDBACK_AUTO_OPEN_DELAY = 10000

const SECTION_BY_PATH = [
  [/^\/competitive-intelligence\/research(?:\/|$)/, 'research'],
  [/^\/competitive-intelligence\/market(?:\/|$)/, 'market-intelligence'],
  [/^\/competitive-intelligence\/assistants(?:\/|$)/, 'ai-assistants'],
  [/^\/competitive-intelligence(?:\/|$)/, 'overview'],
]

export const competitorFeedbackContext = pathname => {
  const route = String(pathname || '').split('?')[0].split('#')[0]
  const match = SECTION_BY_PATH.find(([pattern]) => pattern.test(route))
  return match ? { route, section: match[1] } : null
}

export const competitorFeedbackStorageKeys = userId => ({
  enteredAt: `mag.competitorFeedback.enteredAt.v1:${userId || 'anonymous'}`,
  promptShown: `mag.competitorFeedback.promptShown.v1:${userId || 'anonymous'}`,
})
